import { BaseTheme } from "@swiggy-private/dls-web-common/dist/components/themes/Base";
import { IColorMode, ITheme } from "@swiggy-private/dls-web-common/dist/components/types";

export const CUSTOM_BASE_THEME: Record<string, ITheme> = {
    THEME_DIGITAL_MENU_BRAND_BLUE: {
        ...BaseTheme,
        colors: {
            light: {
                ...BaseTheme.colors.light,
                primary: "#054D80",
                positive: "#054D80",
                secondary: "#021F33",
                background_Secondary: "#FCF9F5",
                background_Tertiary: "#082233",
                border_Selected: "#06558C",
                background_Button_Primary: "#0765A6",
                background_Button_Secondary: "#E9F0F5",
                text_Button_Secondary: "#065D99",
            },
            dark: {
                ...BaseTheme.colors.dark,
            },
        },
    },
    THEME_DIGITAL_MENU_BRAND_GREEN: {
        ...BaseTheme,
        colors: {
            light: {
                ...BaseTheme.colors.light,
                primary: "#468061",
                positive: "#468061",
                secondary: "#1C3326",
                background_Secondary: "#E9F5EF",
                background_Tertiary: "#1C3327",
                border_Selected: "#4D8C6A",
                background_Button_Primary: "#5BA67E",
                background_Button_Secondary: "#E9F5EF",
                text_Button_Secondary: "#549974",
            },
            dark: {
                ...BaseTheme.colors.dark,
            },
        },
    },
    THEME_DIGITAL_MENU_BRAND_BLACK: {
        ...BaseTheme,
        colors: {
            light: {
                ...BaseTheme.colors.light,
                primary: "#262B33",
                positive: "#262B33",
                secondary: "#0A0B0D",
                background_Secondary: "#E9EDF5",
                background_Tertiary: "#0A0B0D",
                border_Selected: "#303640",
                background_Button_Primary: "#262B33",
                background_Button_Secondary: "#E9EDF5",
                text_Button_Secondary: "#303640",
            },
            dark: {
                ...BaseTheme.colors.dark,
            },
        },
    },
    THEME_DIGITAL_MENU_BRAND_ORANGE: {
        ...BaseTheme,
        colors: {
            light: {
                ...BaseTheme.colors.light,
                primary: "#802800",
                positive: "#802800",
                secondary: "#331000",
                background_Secondary: "#F5EDE9",
                background_Tertiary: "#331000",
                border_Selected: "#8C2C00",
                background_Button_Primary: "#A63500",
                background_Button_Secondary: "#F5EDE9",
                text_Button_Secondary: "#993000",
            },
            dark: {
                ...BaseTheme.colors.dark,
            },
        },
    },
};

export const THEME_STORAGE_KEY = "theme-mode";
export const VALID_THEMES: IColorMode[] = ["light", "dark"];
